/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import SlickSlider from "./components/slick";


var prevArrowHTML = '<button class="slick-prev btn" aria-label="Previous" type="button"><span class="material-icons-outlined">arrow_back_ios</span></button>';
var nextArrowHTML = '<button class="slick-next btn" aria-label="Next" type="button"><span class="material-icons-outlined">arrow_forward_ios</span></button>';
$(document).ready(function () {
  $('.products--slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      variableWidth: true,
      prevArrow: prevArrowHTML,
      nextArrow: nextArrowHTML,
      rows: 0,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            variableWidth: false,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 540,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
          },
        },
      ],
  });
});
$(document).ready(function () {
  $('.product--slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      variableWidth: false,
      slidesToShow: 2,
      prevArrow: prevArrowHTML,
      nextArrow: nextArrowHTML,
      rows: 0,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            variableWidth: false,
            slidesToShow: 1,
          },
        },
      ],
  });
});

$(document).ready(function () {
  $('.products_same_categ--slider').slick({
      dots: false,
      infinite: true,
      speed: 300,
      variableWidth: false,
      slidesToShow: 4,
      prevArrow: prevArrowHTML,
      nextArrow: nextArrowHTML,
      rows: 0,
      responsive: [
        {
          breakpoint: 1340,
          settings: {
            slidesToShow: 3,
          },
        },{
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },{
          breakpoint: 520,
          settings: {
            slidesToShow: 1,
          },
        }
      ],
  });
});
